module.exports = __webpack_public_path__ + "img/reason.e0eec0bf.svg";